import {
  DashboardOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  PieChartOutlined,
  BorderOutlined,
  EnvironmentOutlined,
  AntDesignOutlined,
  SafetyOutlined,
  HomeOutlined,
  StopOutlined,
  DotChartOutlined,
  NodeExpandOutlined,
  MailOutlined,
  MessageOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  BulbOutlined,
  InfoCircleOutlined,
  CompassOutlined,
  LayoutOutlined,
  DesktopOutlined,
  FileDoneOutlined,
  CommentOutlined,
  RobotOutlined,
  PlusCircleOutlined,
  FundOutlined,
  VerifiedOutlined,
  ShoppingCartOutlined,
  BookOutlined,
  FileUnknownOutlined,
  FundProjectionScreenOutlined,
  UsergroupAddOutlined,
  FormatPainterOutlined,
  NotificationOutlined,
  UserOutlined,
  ApartmentOutlined,
  SettingOutlined,
  BorderOuterOutlined,
  AlignCenterOutlined,
  CheckSquareOutlined,
  MedicineBoxOutlined,
  BuildOutlined,
  DeliveredProcedureOutlined,
  ExperimentOutlined,
  ShoppingFilled,
  ShopOutlined,
  FileImageOutlined,
  FileOutlined,
  SafetyCertificateOutlined,
  MoneyCollectOutlined,
  UserSwitchOutlined,
  ExpandOutlined,
  PercentageOutlined,
  CalculatorOutlined,
  AuditOutlined,
  FileProtectOutlined,
  StarOutlined,
  TransactionOutlined,
  AccountBookOutlined,
  AppstoreAddOutlined,
  TagsOutlined,
  FormOutlined,
  ContactsOutlined,
  CameraOutlined,
  PlayCircleOutlined,
  FlagOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import { ShippingSVG } from "assets/svg/icon";
import * as routeKeys from "constants/RoutesKeys";
import { getAdminBasePath, getPageBasePath } from "constants/PageRoutes";

const dashBoardNavTree = [
  {
    key: "dashboards",
    path: `${APP_PREFIX_PATH}/dashboards`,
    title: "sidenav.dashboard",
    icon: DashboardOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: 'dashboards-default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        title: 'sidenav.dashboard.default',
        isPage: true,
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const adminsNavTree = [
  {
    key: "admins",
    path: `${APP_PREFIX_PATH}/admins`,
    title: "Admins",
    icon: UserSwitchOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: routeKeys.subadminsKey,
        path: getAdminBasePath(routeKeys.subadminsKey),
        title: "Subadmins",
        isPage: true,
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.subadminRolesKey,
        path: getAdminBasePath(routeKeys.subadminRolesKey),
        title: "Roles & Permissions",
        isPage: true,
        icon: UserSwitchOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const pagesNavTree = [
  {
    key: "pages",
    path: `${APP_PREFIX_PATH}/pages`,
    title: "sidenav.pages",
    icon: InfoCircleOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: routeKeys.branchKey,
        path: getPageBasePath(routeKeys.branchKey),
        title: "Branch",
        isPage: true,
        icon: ApartmentOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.shiftKey,
        path: getPageBasePath(routeKeys.shiftKey),
        title: "Shift",
        isPage: true,
        icon: CalendarOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.shiftApplicationKey,
        path: getPageBasePath(routeKeys.shiftApplicationKey),
        title: "Shift Application",
        isPage: true,
        icon: FileDoneOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.timesheetKey,
        path: getPageBasePath(routeKeys.timesheetKey),
        title: "Timesheet",
        isPage: true,
        icon: ClockCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.transactionKey,
        path: getPageBasePath(routeKeys.transactionKey),
        title: "Transaction",
        isPage: true,
        icon: TransactionOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: routeKeys.ledgerKey,
        path: getPageBasePath(routeKeys.ledgerKey),
        title: "Ledger",
        isPage: true,
        icon: AccountBookOutlined,
        breadcrumb: false,
        submenu: [],
      },
      // {
      //   key: routeKeys.staffDocumentsKey,
      //   path: getPageBasePath(routeKeys.staffDocumentsKey),
      //   title: "Staff Documents",
      //   isPage: true,
      //   icon: FileProtectOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },

      //     {
      //       key: "general-pages",
      //       path: `${APP_PREFIX_PATH}/pages`,
      //       title: "Pages",
      //       isMenu: true,
      //       icon: FileOutlined,
      //       breadcrumb: false,
      //       submenu: [
      //         {
      //           key: routeKeys.categoriesKey,
      //           path: getPageBasePath(routeKeys.categoriesKey),
      //           title: "Categories",
      //           isPage: true,
      //           icon: AppstoreAddOutlined,
      //           breadcrumb: false,
      //           submenu: [],
      //         },
      //         {
      //           key: routeKeys.pagesKey,
      //           path: getPageBasePath(routeKeys.pagesKey),
      //           title: "Pages",
      //           isPage: true,
      //           icon: FileOutlined,
      //           breadcrumb: false,
      //           submenu: [],
      //         }
      //       ],
      //     },
      // {
      //   key: "locality",
      //   title: "Locality",
      //   path: `${APP_PREFIX_PATH}/pages`,
      //   icon: HomeOutlined,
      //   breadcrumb: false,
      //   isMenu: true,
      //   submenu: [
      //     {
      //       key: routeKeys.countryKey,
      //       path: `${APP_PREFIX_PATH}/pages/country-list`,
      //       title: "Country",
      //       isPage: true,
      //       icon: EnvironmentOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     },
      //     {
      //       key: routeKeys.stateKey,
      //       path: `${APP_PREFIX_PATH}/pages/state-list`,
      //       title: "State",
      //       isPage: true,
      //       icon: EnvironmentOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     },
      //   ],
      // },
      // {
      //   key: "dashboards-article-suggestion",
      //   path: `${APP_PREFIX_PATH}/dashboards/article-suggestion`,
      //   title: "Suggested Articles",
      //   permissionKey: "article_suggestions",
      //   icon: FormOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: routeKeys.widgetsKey,
      //   path: getPageBasePath(routeKeys.widgetsKey),
      //   title: "Widgets",
      //   isPage: true,
      //   icon: LayoutOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: routeKeys.bannerKey,
      //   path: getPageBasePath(routeKeys.bannerKey),
      //   title: "Banner",
      //   isPage: true,
      //   icon: FileImageOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: routeKeys.templateKey,
      //   path: `${APP_PREFIX_PATH}/pages/template`,
      //   title: "Templates",
      //   isPage: true,
      //   icon: AppstoreOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: routeKeys.contactUsKey,
      //   path: getPageBasePath(routeKeys.contactUsKey),
      //   title: "Contact Us",
      //   isPage: true,
      //   icon: MessageOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: routeKeys.seoKey,
      //   path: getPageBasePath(routeKeys.seoKey),
      //   title: "SEO",
      //   isPage: true,
      //   icon: SafetyOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      {
        key: routeKeys.notificationKey,
        path: getPageBasePath(routeKeys.notificationKey),
        title: "Notifications",
        isPage: true,
        icon: NotificationOutlined,
        breadcrumb: false,
        submenu: [],
      },
      // {
      //   key: routeKeys.informationPolicyKey,
      //   path: getPageBasePath(routeKeys.informationPolicyKey),
      //   title: "Information policy",
      //   isPage: true,
      //   icon: FileProtectOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: routeKeys.adminSettingsKey,
      //   path: getPageBasePath(routeKeys.adminSettingsKey),
      //   title: "Settings",
      //   isPage: true,
      //   icon: SettingOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: routeKeys.configSettingsKey,
      //   path: getPageBasePath(routeKeys.configSettingsKey),
      //   title: "Config Settings",
      //   isPage: true,
      //   icon: SettingOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },

      // {
      //   key: "dashboards-users",
      //   path: `${APP_PREFIX_PATH}/dashboards/users`,
      //   title: "Users",
      //   icon: UsergroupAddOutlined,
      //   breadcrumb: false,
      //   submenu: [
      //     {
      //       key: "dashboards-users-usergroup",
      //       path: `${APP_PREFIX_PATH}/dashboards/users/usergroup/usergroup-list`,
      //       title: "User Group",
      //       permissionKey: "users-userGroup",
      //       icon: UsergroupAddOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     },
      //     {
      //       key: "dashboards-users-customers",
      //       path: `${APP_PREFIX_PATH}/dashboards/users/customer/customer-list`,
      //       title: "Customer",
      //       permissionKey: "users-customer",
      //       icon: UserOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     },

      //     {
      //       key: "dashboards-users-vendors",
      //       path: `${APP_PREFIX_PATH}/dashboards/users/vendor/vendor-list`,
      //       title: "Vendor",
      //       permissionKey: "users-vendor",
      //       icon: UserOutlined,
      //       breadcrumb: false,
      //       submenu: [],
      //     },
      //   ],
      // },
    ],
  },
];

// {
//   key: 'dashboards-catalog-medicinetype',
//   path: `${APP_PREFIX_PATH}/dashboards/catalog/medicinetype/medicinetype-list`,
//   title: 'Medicine Type',
//   icon: FormatPainterOutlined,
//   breadcrumb: false,
//   submenu: [],
// },
// {
//   key: 'dashboards-catalog-manufacturer',
//   path: `${APP_PREFIX_PATH}/dashboards/catalog/manufacturer/manufacturer-list`,
//   title: 'Manufacturer',
//   icon: FormatPainterOutlined,
//   breadcrumb: false,
//   submenu: [],
// },
// {
//   key: 'dashboards-catalog-composition',
//   path: `${APP_PREFIX_PATH}/dashboards/catalog/composition/composition-list`,
//   title: 'Composition',
//   icon: FormatPainterOutlined,
//   breadcrumb: false,
//   submenu: [],
// },

const docsNavTree = [
  {
    key: "docs",
    path: `${APP_PREFIX_PATH}/docs`,
    title: "sidenav.docs",
    icon: BookOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "docs-documentation",
        path: `${APP_PREFIX_PATH}/docs/documentation`,
        title: "sidenav.docs.documentation",
        isPage: true,
        icon: FileUnknownOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [
  ...dashBoardNavTree,
  // ...adminsNavTree,
  ...pagesNavTree,
  // ...appsNavTree,
  // ...componentsNavTree,
  // ...extraNavTree,
  ...docsNavTree,
];

export default navigationConfig;
